import React from 'react';
import Swiper from '../../com/swiper-3.3.1.min';
import '../../com/swiper-3.3.1.min.css';
import './Banner.less';

export interface IBannerPropType {
    prefixCls?: string;
    bannerList: any[];
    onClick?: any;
    isRecommend?: boolean; // 是否是首页
    style?: any,
}

class Banner extends React.Component<IBannerPropType, any> {
    state = {
        showFindRule: false,
        isRecommend: false,
    };

    static defaultProps = {
        prefixCls: 'banner'
    };

    private swipperNode: HTMLElement;
    private pagination: HTMLElement;
    private refMap = {
        swipperNode: (obj) => this.swipperNode = obj,
        pagination: (obj) => this.pagination = obj
    };
    swiper: any;

    componentDidMount() {
        this.swiper = new Swiper(this.swipperNode, {
            autoplay: 3000,
            observer: true,
            observeParents: true,
            speed: 700,
            autoplayDisableOnInteraction: false,
            loop: true,
            spaceBetween: 90,
            centeredSlides: true,
            slidesPerView: 'auto',
            pagination: this.pagination,
            paginationType: 'custom',
            paginationCustomRender: this.props.bannerList.length <= 1 ? null : (swiper, current, total) => {
                let customPaginationHtml: string = '';
                for (let i = 0; i < total; i++) {
                    // 判断哪个分页器此刻应该被激活
                    if (i == (current - 1)) {
                        customPaginationHtml += '<span class="swiper-pagination-customs swiper-pagination-customs-active"></span>';
                    } else {
                        customPaginationHtml += '<span class="swiper-pagination-customs"></span>';
                    }
                }
                return customPaginationHtml;
            },
            breakpoints: {
                668: {
                    slidesPerView: 1,
                }
            }
        });
    }

    render() {
        const {prefixCls, bannerList, onClick, style} = this.props;
        return (
            <div className={`${prefixCls}-container swiper-container`} style={style} ref={this.refMap.swipperNode}>
                <div className="swiper-wrapper">
                    {
                        bannerList.map((item, index) => {
                            return (
                                <div className={"swiper-slide" + (index === 0 ? ' swiper-slide-center none-effect' : '')} key={item.id} onClick={() => {
                                    onClick && onClick(item);
                                }}>
                                    <div className={`${prefixCls}-imgBox`}>
                                        <img className={`${prefixCls}-image`} src={item.imgUrl} alt=""/>
                                    </div>
                                    <div className="layer-mask" />
                                </div>
                            );
                        })
                    }
                </div>
                <div className="swiper-pagination" ref={this.refMap.pagination}/>
            </div>
        );
    }
}


export default Banner;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/banner/Banner.tsx